import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { saveLastVisitedURL } from "../helpers/authStorage";
import { useDispatch } from "react-redux";

import { useLocalProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props: any) => {
  const dispatch: any = useDispatch();
  const { userProfile, loading, token } = useLocalProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  // Save last visited URL

  const location = useLocation();

  useEffect(() => {
    const fullURL = location.pathname + location.search;
    saveLastVisitedURL(fullURL, userProfile?.userId);
  }, [location, userProfile?.userId]);

  /*
   If user is not logged in and user profile is not available, redirect to login page
  */

  if (!userProfile && loading && !token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <>{props.children}</>;
};

export default AuthProtected;
